import { render, staticRenderFns } from "./sysuser_auth_config.vue?vue&type=template&id=1116a15a&scoped=true"
import script from "./sysuser_auth_config.vue?vue&type=script&lang=js"
export * from "./sysuser_auth_config.vue?vue&type=script&lang=js"
import style0 from "./sysuser_auth_config.vue?vue&type=style&index=0&id=1116a15a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116a15a",
  null
  
)

export default component.exports